import { useDispatch } from 'react-redux';

import { MOVABLE_INK_INTEGRATIONS_DELETE_URL } from 'api/MovableInkIntegrationsAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

import { useTranslations } from '../hooks/useTranslations';
import { NoOp } from 'utils/noop';

type MovableInkIntegrationRequest = {
  tokenId: number;
};

export const useDeleteIntegration = (successCb?: NoOp) => {
  const { t } = useTranslations();
  const dispatch = useDispatch();
  const { mutate, isLoading } = useRestMutation<unknown, MovableInkIntegrationRequest>(
    MOVABLE_INK_INTEGRATIONS_DELETE_URL,
    ApiMethod.post,
    {
      onSuccess() {
        dispatch(addPositiveToast(t('toast.deleteSuccess')));
        successCb?.();
      },
      onError() {
        dispatch(addNegativeToast(t('toast.deleteError')));
      },
    },
  );
  const deleteIntegration = (tokenId: number) => mutate({ tokenId });

  return {
    deleteIntegration,
    isLoading,
  };
};
